import { Routes } from "@angular/router";
import { adminChildGuard, adminGuard, adminOrValuationAdminChildGuard, adminOrValuationAdminGuard } from "./auth/admin.guard";
import { authGuard } from "./auth/auth.guard";
import { EmailRedirectGuard } from "./auth/email-redirect-guard.guard";
import { managerOrCoordinatorGuard } from "./auth/manager.guard";
import { LayoutPage } from "./layout/layout.page";
import { PageNotFoundPage } from "./public/page-not-found/page-not-found.page";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "user",
    pathMatch: "full",
  },
  {
    path: "login",
    loadComponent: () =>
      import("./auth/login/login.page").then((m) => m.LoginPage),
  },
  {
    path: "onboarding",
    loadComponent: () =>
      import("./auth/onboarding/onboarding.page").then(
        (m) => m.OnboardingPage
      ),
  },
  {
    path: "link-profile",
    loadComponent: () =>
      import("./auth/link-profile/link-profile.page").then(
        (m) => m.LinkProfilePage
      ),
  },
  {
    path: "maintenance",
    loadComponent: () =>
      import("./maintenance/maintenance.page").then(
        (m) => m.MaintenancePage
      ),
  },
  {
    path: "error404",
    loadComponent: () => import("./public/page-not-found/page-not-found.page").then( m => m.PageNotFoundPage),
  },
  {
    path: '',
    component: LayoutPage,
    children: [
      {
        path: 'user',
        canActivate: [authGuard, EmailRedirectGuard],
        loadChildren: () => import('./user/user.routes').then(m => m.userRoutes),
        data: { role: 'user' },
      },
      {
        path: 'manager',
        // Coordinators reach deals and valuations only; manager-only children
        // add managerGuard in MyAgencyPageRoutingModule.
        canActivate: [authGuard, managerOrCoordinatorGuard],
        loadChildren: () => import('./manager/my-agency/my-agency.module').then(m => m.MyAgencyPageModule),
      },
      {
        path: 'admin',
        canActivate: [authGuard, adminOrValuationAdminGuard],
        canActivateChild: [adminOrValuationAdminChildGuard],
        loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES),
      },
    ],
  },
  {
    path: "**",
    pathMatch: "full",
    component: PageNotFoundPage,
  }
];
